module.exports = __webpack_public_path__ + "static/media/1033156.74a3ce0d.jpg";